function TopBar(){
    return(
        <footer className="w-full h-14 bg-[#0a1622] fixed top-0 left-0 z-10 flex items-center px-6"></footer>

    )
    
}

export default TopBar